import { type Phase } from './tokens';

export function cn(...inputs: (string | undefined | null | false)[]): string {
  return inputs.filter(Boolean).join(' ');
}

export function getPhaseColor(phase: Phase, shade: 600 | 50 = 600) {
  const shadeKey = shade === 50 ? 50 : 600;
  const tokens = {
    color: {
      phase: {
        decide: { 600: '#0B6E4F', 50: '#E6F3EF' },
        engage: { 600: '#155FA0', 50: '#E7F0FA' },
        gather: { 600: '#6A1B9A', 50: '#F3E8F7' },
        arrange: { 600: '#D35400', 50: '#FCEFE6' },
        prioritize: { 600: '#B71C1C', 50: '#FCEBEC' }
      }
    }
  };
  return tokens.color.phase[phase][shadeKey];
}

export function getPhaseClasses(phase: Phase, shade: 600 | 50 = 600) {
  const color = getPhaseColor(phase, shade);
  if (shade === 600) {
    return { color };
  } else {
    return { backgroundColor: color };
  }
}

export function formatPhaseName(phase: Phase): string {
  const phaseNames = {
    decide: 'Decide',
    engage: 'Engage', 
    gather: 'Gather',
    arrange: 'Arrange',
    prioritize: 'Prioritize'
  };
  return phaseNames[phase];
}

export function getPhaseDescription(phase: Phase): string {
  const descriptions = {
    decide: 'Commit to Prioritizing Intentionally',
    engage: 'Align on Purpose, People, and Constraints',
    gather: 'Capture Options & Evidence',
    arrange: 'Make Sense, Compare, and Balance',
    prioritize: 'Choose, Sequence, and Commit'
  };
  return descriptions[phase];
}

